(function ($, Cobalt, undefined) {
    Cobalt.CP =
    {
        initialize: function () {
            Cobalt.CP.toggleCommentableRating();
            Cobalt.CP.userCPIsReadOnly();
        },
        toggleCommentableRating: function() {
            var $ratingFields = $(".j-rating-type-field");
            if ($ratingFields.length > 0) {
                var $enableRatings = $("input[id*='enableratings']");
                $enableRatings.each(function() {
                    var $that = $(this);

                    $that.on("click", function() {
                        if ($that.prop("checked")) {
                            $that.parents(".expandable").find(".j-rating-type-field").removeClass("hide");
                        } else {
                            $that.parents(".expandable").find(".j-rating-type-field").addClass("hide");
                        }
                    });
                });

                $ratingFields.on("change", function() {
                    alert("WARNING! When changed, any prior ratings for this entity type will be removed!");
                });
            }
        },
        userCPIsReadOnly: function () {
            var $editUser = $(".user-edit.user-cp-read-only");
            if ($editUser.length > 0) {
                $editUser.find(":input").prop('disabled', true);
                $editUser.find("#form-field-email,#form-field-mobile-phone-number").hide();

                //fallback handler
                $editUser.find("form").on("click", "input[type='submit']", function(e) {
                    e.preventDefault();

                    $.get("cp/users/validate-edit", function(data) {
                        if (data) {
                            if (data.isValid) {
                                $(this).parents("form").submit();
                            }
                        }
                    });
                });
            }
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CP.js